import React from 'react'
import styles from './FilterSidebarAufgaben.Module.css'
import { Container, Row, Col, Form, Button } from 'react-bootstrap'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

function FilterSidebarAufgaben(props) {

    return (
        <div style={{
             
                marginTop: "0px",
                position: "absolute",
                zIndex: "1000",
                top: "0",
                right: "0",
                background: "#55aacf",
                paddingTop: "-50px"    
        }}>
            <Row style={{marginLeft: "20px", width: "100%", display: "flex", justifyContent: "space-between"}}>
                <Col>
                    <h4 style={{margin: "0px", padding: "0px"}}>Filter</h4>
                </Col>
                <Col style={{alignItems: "center", marginRight: "20px"}}>
                    <FontAwesomeIcon
                    style={{width: "auto", cursor: "pointer", marginRight: "5px" }}
                    icon={faXmark}
                    size="lg"
                    onClick={() => props.setFilterIsOpen(false)}
                />
                </Col>
            </Row>
            <Row style={{marginLeft: "20px", width: "260px"}}>
                
                {/*

                    <hr />
                    <Form.Label>Suche nach KdNr</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Webseite"
                        name="webseite"
                        
                    />
                */}

                <hr style={{marginTop: "15px"}} />
                <h5>Bestätigungen</h5>
                
                <Form.Check
                    type="checkbox"
                    id="appzugriffCb"
                    label="VIN App"
                    name="appzugriffCb"
                    checked={props.data.appzugriffCb ? true : false}
                    onChange={(e) => props.setCBs(e)}
                />

                <Form.Check
                    type="checkbox"
                    id="maklervollmachtCb"
                    label="Maklervollmacht"
                    name="maklervollmachtCb"
                    checked={props.data.maklervollmachtCb ? true : false}
                    onChange={(e) => props.setCBs(e)}
                />
                
                <Form.Check
                    type="checkbox"
                    id="connectCb"
                    label="Connect durchgef."
                    name="connectCb"
                    checked={props.data.connectCb ? true : false}
                    onChange={(e) => props.setCBs(e)}
                />

                <Form.Check
                    type="checkbox"
                    id="tippgeber_verifiziertCb"
                    label="Tippgeber verifiziert"
                    name="tippgeber_verifiziertCb"
                    checked={props.data.tippgeber_verifiziertCb ? true : false}
                    onChange={(e) => props.setCBs(e)}
                />


                <hr style={{marginTop: "15px"}} />
                <h5>Interesse</h5>
                
                <Form.Check
                    type="checkbox"
                    id="exklusivpartner"
                    label="Exklusivpartner"
                    name="exklusivpartner"
                    checked={props.data.exklusivpartner ? true : false}
                    onChange={(e) => props.setCBs(e)}
                />

                <Form.Check
                    type="checkbox"
                    id="investor"
                    label="Investor"
                    name="investor"
                    checked={props.data.investor ? true : false}
                    onChange={(e) => props.setCBs(e)}
                />
                
                <Form.Check
                    type="checkbox"
                    id="tippgeber"
                    label="Tippgeber"
                    name="tippgeber"
                    checked={props.data.tippgeber ? true : false}
                    onChange={(e) => props.setCBs(e)}
                />

                <Form.Check
                    type="checkbox"
                    id="vorteilspaket"
                    label="Vorteilspaket"
                    name="vorteilspaket"
                    checked={props.data.vorteilspaket ? true : false}
                    onChange={(e) => props.setCBs(e)}
                />

                <Form.Check
                    type="checkbox"
                    id="rabattpartner"
                    label="Rabattpartner"
                    name="rabattpartner"
                    checked={props.data.rabattpartner ? true : false}
                    onChange={(e) => props.setCBs(e)}
                />

            </Row>
        </div>
    )
}

export default FilterSidebarAufgaben